import { render } from "./StatusBadge.vue?vue&type=template&id=d3c2cc78"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"

import "./StatusBadge.vue?vue&type=style&index=0&id=d3c2cc78&lang=css"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__